import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../components/shared/Loader";
import { useDispatch } from "react-redux";
import { updateMeta } from "../../store/actions/metaAction";

const RolesCreate = () => {
	const history = useHistory();
	const [permissions, setPermissions] = useState([]);
	const [slug, setSlug] = useState("");
	const [selectedPermissions, setSelectedPermissions] = useState([]);
	const [loading, setLoading] = useState(true);
	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "اضافية صلاحية جديدة",
				breadcrumb: "صلاحيات المشرفين",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
		axios
			.get(process.env.REACT_APP_API_URL + "/permissions", {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setPermissions(response.data.data);
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
				setLoading(false);
			});
	};

	const handleSelect = permission => {
		if (selectedPermissions.includes(permission)) {
			const arr = selectedPermissions.filter(item => item !== permission);
			setSelectedPermissions(arr);
		} else {
			setSelectedPermissions(arr => [...arr, permission]);
		}
	};

	const handleSubmit = e => {
		e.preventDefault();
		if (selectedPermissions.length === 0) {
			toast.error("برجاء اختيار صلاحية واحدة على الأقل");
		} else {
			setLoading(true);
			axios
				.post(`${process.env.REACT_APP_API_URL}/roles`, {
					slug: slug,
					permission: selectedPermissions,
				})
				.then(function (response) {
					history.push("/roles/index");
					setLoading(false);
					toast.success("تم اضافة الرتبة بنجاح!");
				})
				.catch(function (error) {
					toast.error("خطأ، برجاء المحاولة مره اخرى!");
					setLoading(false);
				});
		}
	};

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit}>
				<div className="form-item">
					<label htmlFor="">اسم الصلاحية</label>
					<input type="text" onChange={e => setSlug(e.target.value)} required />
				</div>
				<div className="row gy-4">
					{permissions.map(permission => (
						<div key={permission.module_name} className="col-md-3">
							<div className="perItem">
								<h1>{permission.slug}</h1>
								<ul className="list-unstyled">
									{permission.permissions.map(per => (
										<li key={per.id}>
											<input
												type="checkbox"
												id={per.name}
												onChange={() => handleSelect(per.name)}
											/>
											<label htmlFor={per.name}>{per.slug}</label>
										</li>
									))}
								</ul>
							</div>
						</div>
					))}
				</div>
				<div className="form-item" style={{ marginTop: "30px" }}>
					<button className="bt bt-success">ارسال</button>
				</div>
			</form>
		</section>
	);
};

export default RolesCreate;
